module.exports = __webpack_public_path__ + "img/client29.a4d86b39.svg";